import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FeatureFlag } from '@app/enums';
import { BenefitDeductionFrequency } from '@app/models/payroll/company/benefit-deduction-frequency.model';
import { FeatureService } from '@app/services/feature.service';
import { BaseForm } from '@forms/base.form';
import { BenefitType } from '@models/payroll/benefit-type.model';
import { CompanyBenefit } from '@models/payroll/company/benefit.model';

const { SORT_ORDER } = BenefitDeductionFrequency;

@Component({
    selector: 'app-company-benefit-form',
    templateUrl: './company-benefit.template.html',
})
export class CompanyBenefitForm extends BaseForm implements OnInit {
    @Input() benefit: CompanyBenefit = new CompanyBenefit();
    @Input() benefitTypes?: BenefitType[];

    /**
     * When this is set to true, the following will happen:
     * - frequency will be required
     * - None and just once will not be frequency options
     * - benefitTypeId input will be hidden
     */
    @Input() hrBenefitMode = false;
    @Output() benefitTypeChange: EventEmitter<number> = new EventEmitter<number>();
    dropdownFrequencyOptions: { label: string; value: number }[] = [];
    hasBenefitsPayroll = false;

    constructor(private featureService: FeatureService) {
        super();

        this.getBenefitDeductionFrequencies();
    }

    async ngOnInit(): Promise<void> {
        const hasBenefitsPayroll = await this.featureService.has(FeatureFlag.benefitsPayroll);
        this.hasBenefitsPayroll = hasBenefitsPayroll;
    }

    submit(): void {
        if (this.benefit.name?.includes('.')) {
            this.form.controls['name'].setErrors({
                custom: {
                    message: 'forms.payroll.invalidBenefitOrDeductionName',
                },
            });
        }

        this.form.onSubmit(null);
    }

    isNonCashTaxableBenefit(benefitTypeId: number): boolean {
        const selectedBenefitType = this.benefitTypes.filter((benefitType) => benefitType.id === benefitTypeId);
        if (selectedBenefitType.length === 0) {
            return false;
        }
        return selectedBenefitType[0].displayName === 'Taxable Benefit (Non-Cash)';
    }

    private async getBenefitDeductionFrequencies(): Promise<void> {
        const [results] = await BenefitDeductionFrequency.get();

        const options = results.map((result) => {
            return {
                label: result.displayName,
                name: result.name,
                value: result.uuid,
            };
        });

        let list = SORT_ORDER.map((order) => options.find(({ name }) => name == order));

        if (this.hrBenefitMode) {
            list = list.filter((item) => item.name !== 'one_time');
            this.benefit.benefitDeductionFrequencyUuid = list.find((item) => item.name === 'each_period')?.value;
        }

        this.dropdownFrequencyOptions = list;
    }
}
